import React, { useState } from 'react';
import { TextBox } from '../../../';
import { Panel, PanelTheme, BankAccountBox, EmailBox, PasswordBox, PhoneBox, UrlBox, ZipCodeBox } from '@apply/components';
import { CustomRule } from 'devextreme-react/validator';

export const TextBoxDemo: React.FC = () => {
    // State for each example
    const [basicValue, setBasicValue] = useState('');
    const [readOnlyValue, setReadOnlyValue] = useState('Read only value');
    const [requiredValue, setRequiredValue] = useState('');
    const [customValue, setCustomValue] = useState('');

    //State for child controls
    const [bankAccountNumber, set_bankAccountNumber] = useState('');
    const [email, set_email] = useState('');
    const [password, set_password] = useState('');
    const [phone, set_phone] = useState('');
    const [website, set_website] = useState('');
    const [zipCode, set_zipCode] = useState('');

    // Custom validator: value must include the word "test"
    const customValidator = (
        <CustomRule
            message="Value must include 'test'"
            validationCallback={(e: any) => {
                if (!e.value) return true; // Consider empty valid, or adjust as needed.
                return e.value.includes('test');
            }}
        />
    );

    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h2>Text Box :</h2>
            <br />
            <Panel theme={PanelTheme.White}>
                <div style={{ padding: '1rem' }}>
                    {/* Example 1: Basic TextBox */}
                    <div style={{ marginBottom: '1rem' }}>
                        <TextBox
                            value={basicValue}
                            onChange={setBasicValue}
                            label='Basic TextBox'
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <TextBox
                            value={basicValue}
                            onChange={setBasicValue}
                            label='Basic TextBox with Info Bubble Popup'
                            showInfoIcon={true}
                            infoText='This is some text.'
                        />
                    </div>
                    {/* Example 2: Read-Only TextBox */}
                    <div style={{ marginBottom: '1rem' }}>
                        <TextBox
                            value={readOnlyValue}
                            onChange={setReadOnlyValue}
                            label='Read-Only TextBox'
                            readOnly={true}
                        />
                    </div>

                    {/* Example 3: Required Field */}
                    <div style={{ marginBottom: '1rem' }}>
                        <TextBox
                            value={requiredValue}
                            onChange={setRequiredValue}
                            label='Required TextBox'
                            required={true}
                        />
                    </div>

                    {/* Example 4: Custom Validator */}
                    <div style={{ marginBottom: '1rem' }}>
                        <TextBox
                            value={customValue}
                            onChange={setCustomValue}
                            label='Custom Validator TextBox With Helper Text'
                            helperText="Helper Text: Entry must include the word 'test'."
                            validator={customValidator}
                        />
                    </div>
                    <br />
                    <h6>Components that Inherit from Textbox</h6>
                    <div style={{ marginBottom: '1rem' }}>
                        <BankAccountBox
                            value={bankAccountNumber}
                            label='Bank Account (Last 4 Digits):'
                            onChange={set_bankAccountNumber}
                            width='100%'
                            maxLength={4}
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <BankAccountBox
                            value={bankAccountNumber}
                            label='Bank Account (Last 4 Digits):'
                            onChange={set_bankAccountNumber}
                            width='100%'
                            maxLength={4}
                            showInfoIcon={true}
                            infoText='Bank Account with 4 digits'
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <EmailBox
                            id='emailAddress'
                            name='emailAddress'
                            value={email}
                            onChange={set_email}
                            label='Email Address'
                            required={true}
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <EmailBox
                            id='emailAddress'
                            name='emailAddress'
                            value={email}
                            onChange={set_email}
                            label='Email Address'
                            required={true}
                            showInfoIcon={true}
                            infoText='Email Address Box'
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <PasswordBox
                            id='password'
                            name='password'
                            value={password}
                            onChange={set_password}
                            label='Password'
                            required={true}
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <PasswordBox
                            id='password'
                            name='password'
                            value={password}
                            onChange={set_password}
                            label='Password'
                            required={true}
                            showInfoIcon={true}
                            infoText='Your password'
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <PhoneBox
                            id='phoneBox'
                            value={phone}
                            onChange={set_phone}
                            label='Phone Number'
                            required={true}
                            width='100%'
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <PhoneBox
                            id='phoneBox'
                            value={phone}
                            onChange={set_phone}
                            label='Phone Number'
                            required={true}
                            width='100%'
                            showInfoIcon={true}
                            infoText='Phone Number Input'
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <UrlBox
                            id='website'
                            value={website}
                            onChange={set_website}
                            label='Website'
                            required={true}
                            width='100%'
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <UrlBox
                            id='website'
                            value={website}
                            onChange={set_website}
                            label='Website'
                            required={true}
                            width='100%'
                            showInfoIcon={true}
                            infoText='Your Website'
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <ZipCodeBox
                            id='zipCode'
                            value={zipCode}
                            onChange={set_zipCode}
                            label='Zip Code'
                            placeholder='01234'
                            required={true}
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <ZipCodeBox
                            id='zipCode'
                            value={zipCode}
                            onChange={set_zipCode}
                            label='Zip Code'
                            placeholder='01234'
                            required={true}
                            showInfoIcon={true}
                            infoText='Zip Code Entry'
                        />
                    </div>
                </div>
            </Panel>
        </div>
    );
};
